import styled from 'styled-components'

export const StyledAboutLon = styled.div`
  a {
    text-decoration: none;
  }

  li {
    list-style: none;
  }

  section {
    .s-inner {
      max-width: 1440px;
      margin: 0 auto;
    }
  }

  .landing-s1 {
    .landing-description {
      margin-bottom: 25px;
      color: #9598ab;
    }

    .landing-title {
      margin-bottom: 18px !important;
    }

    .lon-landing-page-division {
      display: none;
    }

    .s-inner {
      display: flex;
      justify-content: space-between;
      flex-flow: row nowrap;
      padding: 56px 0 89px 0;
      max-width: 1136px;

      h1,
      h2 {
        font-weight: normal;
        font-size: 32px;
        line-height: 42px;
        color: #21213e;
      }

      h2 {
        margin-bottom: 28px;
      }

      a {
        display: inline-block;
        width: 145px;
        padding: 7px 0;
        margin-right: 12px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        text-decoration: none;

        &.btn-1 {
          background: #5f4dbc;
          border-radius: 47.3684px;
          color: #ffffff;
        }
        &.btn-2 {
          background: linear-gradient(180deg, #e0e1f1 0%, #e0e0f1 214.44%);
          border-radius: 41.1071px;
          color: #5f4dbc;
        }
      }

      .s1-left-inner-en {
        a {
          width: 230px;
        }
      }

      img {
        width: 550px;
        min-height: 250px;
      }
      > div {
        &:nth-child(1) {
          display: flex;
          justify-content: center;
          align-items: center;
          .s1-left-inner {
            margin-top: -120px;
            margin-left: -30px;
          }
        }
      }
    }
  }

  .landing-s2 {
    background-color: #5e54a7;
    .s-inner {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 96px 0 95px 0px;

      > div {
        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        img {
          margin-left: 10%;
          width: 73%;
        }

        &:nth-child(2) {
          flex-direction: column;
        }
      }

      h2 {
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
        color: #ffffff;
      }

      dl {
        padding-top: 10px;
        dt {
          position: relative;
          margin-top: 35px;
          font-weight: normal;
          font-size: 21px;
          line-height: 30px;
          color: #ffffff;
          i {
            position: absolute;
            box-sizing: content-box;
            left: -36px;
            top: 5px;
            padding: 5px;
            width: 11px;
            height: 11px;
            background-color: rgba(213, 210, 237, 0.1);
            border-radius: 100%;
            &::after {
              display: block;
              content: '';
              width: 11px;
              height: 11px;
              background: #a29afd;
              border-radius: 100%;
            }
          }
        }
        dd {
          margin-top: 9px;
          font-weight: 300;
          font-size: 17px;
          line-height: 24px;
          letter-spacing: 1px;
          color: #c4c9d9;
        }
      }
    }
  }

  .landing-s3 {
    padding: 96px 0px 95px 0px;
    border-bottom: 1px solid #e1e6ea;
    background: #f6f8fb;

    .s-inner {
      h2 {
        text-align: center;
        font-weight: normal;
        font-size: 32px;
        line-height: 42px;
        color: #21213e;
      }
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 44px 10.5% 0 10.5%;
        li {
          flex: 1;
          max-width: 319px;
          text-align: center;
          img {
            width: 96px;
          }
          h3 {
            margin-top: 12px;
            font-weight: 400;
            font-size: 21px;
            line-height: 31px;
            color: #191c1e;
          }
          p {
            margin-top: 10px;
            font-size: 17px;
            line-height: 25px;
            color: #9598ab;
            font-weight: 300;
          }
        }
      }
    }
  }
  .landing-questions {
    display: flex;
    width: 1219px;
    margin: 0 auto;
    padding: 62px 0 89px 0;
    justify-content: space-between;
    align-items: center;
    box-shadow: inset 0px 1px 0px #e1e6ea;

    .landing-questions-info {
      display: flex;
      flex-direction: column;
    }

    .lon-faq-item {
      width: 507px;
      display: flex;
      justify-content: space-between;
    }

    > div {
      display: flex;
      align-items: center;
      img {
        width: 50px;
      }
      div {
        display: flex;
        h4 {
          margin-left: 26px;
          font-weight: 500;
          font-size: 17px;
          line-height: 21px;
          color: #4e5255;
        }
        a {
          margin-left: 26px;
          font-weight: 300;
          font-size: 17px;
          margin-top: 5px;
          line-height: 21px;
          letter-spacing: 1px;
          color: #9598ab;
        }
      }
    }
  }
  // 移动端适配
  @media screen and (max-width: 640px) {
    .landing-s1 {
      .s-inner {
        padding: 73px 0 73px 0;
        flex-direction: column;
        .s1-left-inner {
          display: flex;
          flex-direction: column;
          justify-content: center;
          h1,
          h2 {
            font-size: 28px;
            line-height: 42px;
          }
          h2 {
            margin-bottom: 25px;
          }
        }
        > div:nth-child(1) .s1-left-inner {
          margin-top: 0;
          margin-left: 0;
        }
        > div {
          text-align: center;
          a {
            display: block;
            margin: 8px auto;
            width: 175px;
            font-size: 17px;
            letter-spacing: 0.8px;
          }
        }
        img {
          margin-top: 56px;
          width: 94.6%;
        }
      }
    }

    .landing-s2 {
      padding-bottom: 60px;

      .s-inner {
        padding: 90px 0 95px 0px;
        flex-direction: column;
        > div {
          dl {
            padding: 10px 20px 0 60px;
          }
          h2 {
            margin-top: 72px;
            text-align: center;
            font-size: 28px;
            line-height: 32px;
          }
          img {
            width: 94.6%;
            margin-left: 0;
          }
        }
      }
    }

    .landing-s3 {
      padding: 0 0 95px 0;

      .s-inner {
        ul {
          margin-top: 30px;
          margin-left: 0;
          li {
            flex: auto;
            max-width: none;
            margin-bottom: 41px;
            width: 100%;
            &:last-child {
              margin-bottom: 0;
            }
            h3 {
              font-size: 21px;
              line-height: 31px;
              font-weight: 300;
            }
            p {
              font-weight: 300;
            }
          }
        }
        h2 {
          font-size: 28px;
          line-height: 42px;
        }
      }
    }
    .landing-questions {
      width: auto;
      flex-direction: column;
      align-items: flex-start;
      margin: 0;
      padding: 0;

      .lon-faq-item {
        width: 100%;
        margin: 0;
        padding: 45px 20px 45px 35px;
        box-shadow: inset 0px 1px 1px #e1e6ea;
      }

      > div {
        margin-left: 40px;
        div {
          h4 {
            margin-left: 18px;
          }
          a {
            margin-left: 18px;
            line-height: 27px;
            font-size: 13px;
          }
        }
      }
      > a {
        margin-left: 108px;
        margin-top: 12px;
      }
    }
    .landing-title {
      padding: 0 20px !important;
    }

    .landing-description {
      padding: 0 20px !important;
    }

    .lon-landing-page-division {
      display: block !important;
    }
  }
`
